import {AssistantState} from './assistant-types';
import {ASSISTANT_ACTION_TYPES, AssistantAction} from './assistant-actions';
import {enableMapSet, produce} from 'immer';
import {getEmptyConversation} from '../common/utils';
import {AiAssistantConversation} from '../common/types';

// Enable Immer support for Set and Map
enableMapSet();

const initialState: AssistantState = {
    showChatSuggestions: null,
    conversations: {},
    isLoadingConversations: false,
    conversationsError: null,
    loadingConversationIds: new Set(),
};

export function assistantReducer(state: AssistantState = initialState, action: AssistantAction): AssistantState {
    return produce(state, (draft: AssistantState) => {
        switch (action.type) {
            case ASSISTANT_ACTION_TYPES.SHOW_CHAT_SUGGESTIONS: {
                draft.showChatSuggestions = action.showChatSuggestions;
                break;
            }
            case ASSISTANT_ACTION_TYPES.SET_SUGGESTIONS: {
                const {suggestions, conversationId} = action;
                if (draft.conversations[conversationId]) {
                    const conversation = draft.conversations[conversationId];
                    if (conversation) {
                        conversation.suggestions = suggestions;
                    }
                } else {
                    console.warn(`Conversation with id ${conversationId} not found.`);
                }
                break;
            }
            case ASSISTANT_ACTION_TYPES.ADD_SUMMARY: {
                const {conversationId, summary} = action;
                if (draft.conversations[conversationId]) {
                    const conversation = draft.conversations[conversationId];
                    if (conversation) {
                        conversation.summary = summary;
                        draft.conversations[conversationId] = conversation;
                    }
                } else {
                    console.warn(`Conversation with id ${conversationId} not found.`);
                }
                break;
            }
            case ASSISTANT_ACTION_TYPES.UPDATE_CONVERSATION_CONTEXT: {
                const conversation: AiAssistantConversation = draft.conversations[action.conversationId];
                if (conversation) {
                    conversation.context = action.context;
                }
                break;
            }
            case ASSISTANT_ACTION_TYPES.LOAD_CONVERSATIONS_LOADING: {
                draft.isLoadingConversations = true;
                draft.conversationsError = null;
                break;
            }
            case ASSISTANT_ACTION_TYPES.LOAD_CONVERSATIONS: {
                draft.conversations = action.conversations;
                draft.isLoadingConversations = false;
                draft.conversationsError = null;
                break;
            }
            case ASSISTANT_ACTION_TYPES.LOAD_CONVERSATIONS_ERROR: {
                draft.isLoadingConversations = false;
                draft.conversationsError = action.error;
                break;
            }
            case ASSISTANT_ACTION_TYPES.START_LOADING_CONVERSATION: {
                draft.loadingConversationIds.add(action.conversationId);
                break;
            }
            case ASSISTANT_ACTION_TYPES.FINISH_LOADING_CONVERSATION: {
                draft.loadingConversationIds.delete(action.conversationId);
                break;
            }
            case ASSISTANT_ACTION_TYPES.CREATE_CONVERSATION_SUCCESS: {
                const {conversationId, message, chatType, role, searchRequest} = action;
                if (draft.conversations[conversationId]) {
                    console.warn(`Conversation with id ${conversationId} already exist.`);
                    break;
                }

                draft.conversations[conversationId] = getEmptyConversation(
                    chatType,
                    conversationId,
                    role,
                    message,
                    searchRequest,
                );
                break;
            }
            case ASSISTANT_ACTION_TYPES.ADD_MESSAGE_SUCCESS: {
                const {conversationId, newMessage, searchRequest} = action;
                if (draft.conversations[conversationId]) {
                    const conversation = draft.conversations[conversationId];
                    if (conversation) {
                        conversation.conversationMessages.push(newMessage);
                        if (searchRequest) {
                            conversation.searchResultsRequests.push(searchRequest);
                        }
                    }
                } else {
                    console.warn(`Conversation with id ${conversationId} not found.`);
                }
                break;
            }
            case ASSISTANT_ACTION_TYPES.DELETE_CONVERSATION_SUCCESS: {
                const {conversationId} = action;
                if (draft.conversations[conversationId]) {
                    delete draft.conversations[conversationId];
                } else {
                    console.warn(`Conversation with id ${conversationId} not found.`);
                }
                break;
            }
        }
    });
}
